/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Schedule = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        departmentId: {
    type: 'number',
    isRequired: true,
},
        facilityId: {
    type: 'number',
},
        facilityName: {
    type: 'string',
},
        shiftId: {
    type: 'number',
},
        assignee: {
    type: 'number',
    isNullable: true,
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        status: {
    type: 'ScheduleStatus',
    isRequired: true,
},
        isUrgent: {
    type: 'boolean',
    isRequired: true,
},
        startTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        endTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        overtime: {
    type: 'boolean',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        bid: {
    type: 'boolean',
    isRequired: true,
},
    },
};